import React from 'react';

import { PaddingContainer, WidthContainer } from '@components';

import * as styles from './Disclaimer.module.scss';

export const Disclaimer: React.FC = () => {
	return (
		<PaddingContainer className="white-bg">
			<WidthContainer className="py-3 py-xl-5">
				<div className={styles.textWrapper}>
					<p className="orange-font font-size-medium text-center">
						If you cannot find the technology you are looking for, do not worry.
						We are part of the biggest IT community and have trusted business
						partners in every technological area.
					</p>
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
